// World-up slide combined with opacity fade on a visibility flip (metres).
export const FADE_SLIDE_OFFSET_Y = 0.3;

// Variant transition timing (ms); a variant's `transitionMs` overrides the settle
// leg and each `animationSteps` entry its own `durationMs`.
export const VARIANT_TWEEN_MS = 350;
export const VARIANT_STEP_MS = 250;
// Per stage of the composite 180° routing (Right↔Left through a neutral pose).
export const VARIANT_ROUTE_STAGE_MS = 250;

export const LEG_HEIGHT_TWEEN_MS = 250;

// Where a sequenced leg (`turn-then-move` / `move-then-turn`) hands over between channels.
export const MOTION_SPLIT = 0.5;
export const easeCubic = (t) => {
  const u = -2 * t + 2;
  return t < 0.5 ? 4 * t * t * t : 1 - (u * u * u) / 2;
};
